import React, { FC, useState } from 'react';
import { ShoppingCart } from 'phosphor-react';
import { Modal } from '../Modal';
import { Button } from '../../Common/Button';
import { ShoppingList } from './ShoppingList';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { AddonListActions, Product, ProductListActions } from '../../../types/webshop';
import { TotalPrice } from './TotalPrice';

interface ShoppingCartModalProps {
  showShoppingCartModal: boolean;
  setShowShoppingCartModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCategoryKey?: string;
  selectedSubcategoryKey?: string;
  price: string;
  vatPrice: string;
  selectedProducts: Product[];
  selectedProductsActions: ProductListActions;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  cmsShopContent: ShopContent;
}

export const ShoppingCartModal: FC<ShoppingCartModalProps> = ({
  showShoppingCartModal,
  setShowShoppingCartModal,
  selectedCategoryKey,
  selectedSubcategoryKey,
  price,
  vatPrice,
  selectedProducts,
  selectedProductsActions,
  selectedAddons,
  selectedAddonsActions,
  cmsShopContent,
}) => {
  const [totalPriceFetching, setTotalPriceFetching] = useState(false);

  return (
    <Modal
      showModal={showShoppingCartModal}
      setShowModal={setShowShoppingCartModal}
      header={
        <div className="flex flex-row items-center">
          <ShoppingCart size={32} className="hidden ml-1 mr-4 sm:block text-sami-green" />
          {cmsShopContent.shoppingCart.shoppingCartModal.title}
        </div>
      }
      content={
        <ShoppingList
          selectedProducts={selectedProducts}
          selectedProductsActions={selectedProductsActions}
          selectedAddons={selectedAddons}
          selectedAddonsActions={selectedAddonsActions}
          setTotalPriceFetching={setTotalPriceFetching}
          selectedCategoryKey={selectedCategoryKey}
          selectedSubcategoryKey={selectedSubcategoryKey}
          cmsShopContent={cmsShopContent}
        />
      }
      actions={
        <div className="mx-auto w-fit">
          <Button
            text={cmsShopContent.shoppingCart.shoppingCartModal.closeButton}
            onClick={() => setShowShoppingCartModal(false)}
          />
        </div>
      }
      bottomStaticInfo={
        <TotalPrice
          price={price}
          vatPrice={vatPrice}
          totalPriceFetching={totalPriceFetching}
          cmsShopContent={cmsShopContent}
        />
      }
    />
  );
};
